import React from 'react';
import { MapPin, Clock, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { businessInfo } from '../mock';

export const Hero = () => {
  const WHATSAPP_LINK = "https://wa.me/33640486009?text=Bonjour%2C%20je%20souhaite%20prendre%20rendez-vous%20%F0%9F%92%85";

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="hero" className="relative min-h-[85vh] md:min-h-screen flex items-center justify-center overflow-hidden pt-16" style={{ backgroundColor: '#E8B4D1' }}>
      {/* Décors subtils */}
      <div className="absolute top-20 left-5 w-32 h-32 md:w-72 md:h-72 bg-white/30 rounded-full mix-blend-multiply filter blur-3xl opacity-40" aria-hidden="true"></div>
      <div className="absolute bottom-20 right-5 w-32 h-32 md:w-72 md:h-72 bg-white/30 rounded-full mix-blend-multiply filter blur-3xl opacity-40" aria-hidden="true"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          
          {/* Logo/Image - Taille réduite sur mobile */}
          <div className="mb-6 md:mb-8 flex justify-center">
            <div className="relative w-40 h-40 sm:w-56 sm:h-56 md:w-72 md:h-72 rounded-3xl overflow-hidden shadow-xl bg-gradient-to-br from-pink-100 to-rose-100 flex items-center justify-center p-4">
              <img 
                src={businessInfo.logo}
                alt="Logo Nailed by Chloé - Nail artist à domicile La Réunion"
                className="w-full h-full object-contain"
                loading="eager"
                width="288"
                height="288"
              />
            </div>
          </div>

          {/* Titre principal - Clair et direct */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800 mb-3 md:mb-4">
            Prothésiste ongulaire
            <span className="block" style={{ color: '#D1477A' }}>à domicile à La Réunion</span>
          </h1>
          
          {/* Sous-titre rassurant */}
          <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-6 md:mb-8 max-w-xl mx-auto leading-relaxed">
            Extensions, semi-permanent, nail art & gainage.
            <span className="block mt-1">Je me déplace chez vous 🌴</span>
          </p>

          {/* Badges services - Texte plus lisible */}
          <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-6 md:mb-8">
            {['Semi-permanent', 'Extensions', 'Nail art', 'Ongles rongés OK'].map((service, index) => (
              <span
                key={index}
                className="px-3 py-2 md:px-4 md:py-2 bg-white/90 backdrop-blur-sm rounded-full text-gray-700 text-sm md:text-base font-medium shadow-sm"
                style={{ borderColor: '#D1477A', borderWidth: '1px' }}
              >
                {service}
              </span>
            ))}
          </div>

          {/* Infos localisation & horaires */}
          <div className="flex flex-col sm:flex-row justify-center gap-3 mb-8">
            <div className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-white/80 backdrop-blur-sm rounded-xl shadow-sm text-sm md:text-base">
              <MapPin style={{ color: '#D1477A' }} className="flex-shrink-0" size={18} aria-hidden="true" />
              <span className="text-gray-700">Ravine des Cabris, La Réunion</span>
            </div>
            <div className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-white/80 backdrop-blur-sm rounded-xl shadow-sm text-sm md:text-base">
              <Clock style={{ color: '#D1477A' }} className="flex-shrink-0" size={18} aria-hidden="true" />
              <span className="text-gray-700">Lun-Sam • 8h-18h</span>
            </div>
          </div>

          {/* CTA UNIQUE - Réserver sur WhatsApp */}
          <div className="flex flex-col sm:flex-row justify-center gap-3 md:gap-4">
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 md:py-5 text-base md:text-lg font-bold text-white rounded-xl shadow-lg hover:shadow-xl transition-all min-h-[52px] active:scale-[0.98]"
              style={{ backgroundColor: '#25D366' }}
            >
              <MessageCircle size={22} aria-hidden="true" />
              Réserver sur WhatsApp
            </a>
            <Button
              onClick={() => scrollToSection('services')}
              size="lg"
              variant="outline"
              className="border-2 border-gray-300 text-gray-700 hover:bg-gray-50 px-8 py-4 md:py-5 text-base md:text-lg shadow-sm hover:shadow-md transition-all rounded-xl min-h-[52px]"
            >
              Voir les tarifs
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
